import { render, staticRenderFns } from "./ProcedureContent.vue?vue&type=template&id=11f7798d"
import script from "./ProcedureContent.vue?vue&type=script&lang=js"
export * from "./ProcedureContent.vue?vue&type=script&lang=js"
import style0 from "./ProcedureContent.vue?vue&type=style&index=0&id=11f7798d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports